const unknown = {
  label: "N/A",
  value: 0,
  color: "#B0B0B0",
  softColor: "#B0B0B0",
};

const ticket_types = [
  { label: "Sello", value: 1, color: "#ffe18a", softColor: "#fff2cc" },
  { label: "Cura de planta", value: 2, color: "#83a1c8", softColor: "#acb9ca" },
  { label: "Raiceador", value: 3, color: "#90d163", softColor: "#a9d08e" },
  { label: "Fertilización", value: 4, color: "#afde8f", softColor: "#c6e0b4" },
  { label: "Abono", value: 5, color: "#2dc9ff", softColor: "#00b0f0" },
  { label: "Herbicida", value: 6, color: "#ffcb2c", softColor: "#ffe699" },
  { label: "Forza", value: 7, color: "#f78b44", softColor: "#f8cbad" },
  { label: "Cura de fruta", value: 8, color: "#6e96ca", softColor: "#abd5ff" },
];

/*
    1 - herbicide
    2 - fertilizer
    3 - insecticide
    4 - fungicide
    5 - additive
    6 - growth_regulator
    7 - biostimulant
    8 - biological_control
    9 - general_product
*/
const product_types = [
  { label: "Herbicida", value: 1, color: "#4cceac" },
  { label: "Fertilizante", value: 2, color: "#4cceac" },
  { label: "Insecticida", value: 3, color: "#4cceac" },
  { label: "Fungicida", value: 4, color: "#4cceac" },
  { label: "Aditivo", value: 5, color: "#4cceac" },
  { label: "Regulador de Crecimiento", value: 6, color: "#4cceac" },
  { label: "Bioestimulante", value: 7, color: "#4cceac" },
  { label: "Control Biológico", value: 8, color: "#4cceac" },
  { label: "Hormiguicida", value: 10, color: "#4cceac" },
  { label: "Enraizador", value: 11, color: "#4cceac" },
  { label: "Coadyuvante", value: 12, color: "#4cceac" },
  { label: "Desinfectante", value: 13, color: "#4cceac" },
  { label: "Regulador PH", value: 14, color: "#4cceac" },
  { label: "Bactericida", value: 14, color: "#4cceac" },
];

/*
    1 - L
    2 - Kg
*/
const product_UOM = [
  { label: "Litros", value: 1 },
  { label: "Kilogramos", value: 2 },
];

/*
    1 - L
    2 - Kg
*/
const block_group_types = [
  { label: "Base", value: 1 },
  { label: "Forza", value: 2 },
  { label: "Dinamic", value: 3 },
];

/*
    1 - rainy
    2 - suny
    3 - cloudly
    4 - clear
    5 - (N/A)
*/
const application_weather = [
  { label: "Lluvioso", value: 1 },
  { label: "Soleado", value: 2 },
  { label: "Nuboso", value: 3 },
  { label: "Despejado", value: 4 },
  { label: "N/A", value: 5 },
];

/*
    1 - pending
    2 - applied
    3 - canceled
    4 - in_progress
*/
const application_status = [
  { label: "Pendiente", value: 1 },
  { label: "Aplicado", value: 2 },
  { label: "Cancelado", value: 3 },
  { label: "En Progreso", value: 4 },
];

/*
    1 - crown
    2 - guide
    3 - basal
*/
const lote_type = [
  { label: "Corona", value: 1, color: "#4cceac" },
  { label: "Guía", value: 2, color: "#4cceac" },
  { label: "Basal", value: 3, color: "#4cceac" },
];

/*
    1 - first
    2 - second
    3 - third
*/
const harvest_tag = [
  { label: "Primera", value: 1, color: "#4cceac" },
  { label: "Segunda", value: 2, color: "#00b0f0" },
  { label: "Tercera", value: 3, color: "#ffe699" },
];

/*
    1 - master
    2 - admin
    3 - operator
*/
const user_type = [
  { label: "Master", value: 1 },
  { label: "Administrador", value: 2 },
  { label: "Operario", value: 3 },
];

/*
    1 - Application
    2 - Extraordinary
    3 - operator
*/
const usage_type = [
  { label: "Aplicación", value: 1, color: "#4cceac" },
  { label: "Extraordinaria", value: 2, color: "#4cceac" },
];

function getTicketTypeByValue(value) {
  return ticket_types.find((ticket) => ticket.value === value) || unknown;
}

function getProductUOMByName(value) {
  return product_UOM.find((UOM) => UOM.value === value) || unknown;
}

function getProductTypeByValue(value) {
  return product_types.find((product) => product.value === value) || unknown;
}

function getBlockGroupTypeByValue(value) {
  return block_group_types.find((status) => status.value === value) || unknown;
}

function getApplicationWeatherByValue(value) {
  return (
    application_weather.find((weather) => weather.value === value) || unknown
  );
}

function getApplicationStatusByValue(value) {
  return application_status.find((status) => status.value === value) || unknown;
}

function getLoteTypeByValue(value) {
  return lote_type.find((type) => type.value === value) || unknown;
}

function getHarvestTypeByValue(value) {
  return harvest_tag.find((type) => type.value === value) || unknown;
}

function getUsageTypeByValue(value) {
  return usage_type.find((type) => type.value === value) || unknown;
}

export {
  ticket_types,
  product_types,
  product_UOM,
  block_group_types,
  application_weather,
  application_status,
  lote_type,
  harvest_tag,
  user_type,
  usage_type,
  getTicketTypeByValue,
  getProductTypeByValue,
  getProductUOMByName,
  getBlockGroupTypeByValue,
  getApplicationWeatherByValue,
  getApplicationStatusByValue,
  getLoteTypeByValue,
  getHarvestTypeByValue,
  getUsageTypeByValue,
};
